var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 102.03,
    width: 172.18,
    height: 117.43,
    rx: 16,
    ry: 16,
    style: {
      fill: "#f4cb96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.55,303.42c-20.39-26.6-28.76-51.16-23.74-92.13h-36.37c1.89,35.27,21.05,74.26,60.11,92.13Z",
    style: {
      fill: "#f4cb96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.55,261.06h4.88v68.27h-4.88c-11.04,0-19.93-8.95-19.93-19.93h0v-28.35c0-11.04,8.95-19.99,19.93-19.99Z",
    style: {
      fill: "#916fa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.79,333.09h-4.88v-68.27h4.88c11.04,0,19.93,8.95,19.93,19.93v28.35c0,11.09-8.95,19.99-19.93,19.99Z",
    style: {
      fill: "#916fa9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.41,
    y: 188.25,
    width: 3.52,
    height: 32.89,
    style: {
      fill: "#27285d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.78,
    y: 352.73,
    width: 38.79,
    height: 37.42,
    style: {
      fill: "#214b96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.01,373.73h134.33c23.7,0,42.94,19.24,42.94,42.94v6.33h-220.21v-6.33c0-23.7,19.24-42.94,42.94-42.94Z",
    style: {
      fill: "#51a6da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.54,237.96c-.48-19.12-16.12-34.48-35.36-34.48s-34.88,15.36-35.36,34.48h70.73Z",
    style: {
      fill: "#214b96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.37,237.71h131.61c9.31,0,16.86,7.15,16.86,15.97v86.15c0,8.82-7.55,15.97-16.86,15.97h-131.61c-9.31,0-16.86-7.15-16.86-15.97v-86.15c0-8.82,7.55-15.97,16.86-15.97Z",
    style: {
      fill: "#51a6da"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.12,
    cy: 278.64,
    r: 26.32,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.12,
    cy: 278.64,
    r: 15.57,
    style: {
      fill: "#27285d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.23,
    cy: 278.64,
    r: 26.32,
    transform: "translate(-40.7 508) rotate(-79.1)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.23,
    cy: 278.64,
    r: 15.57,
    style: {
      fill: "#27285d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.81,310.1c.48,19.12,16.12,34.48,35.36,34.48s34.88-15.36,35.36-34.48h-70.73Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.17,
    cy: 185.51,
    r: 7.44,
    style: {
      fill: "#214b96"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.5 131.46 196.3 119.26 139.41 176.15 118.51 155.25 106.31 167.45 139.34 200.48 139.41 200.42 139.48 200.48 208.5 131.46",
    style: {
      fill: "#60a286"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    style: {
      fill: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustRobot);
export default __webpack_public_path__ + "static/media/Illust_Robot.2693bafce15140d2b007db8ab96b0939.svg";
export { ForwardRef as ReactComponent };